<template>
  <div class="space-y-4">
    <!-- Admin Toggle -->
    <div class="flex items-center justify-between">
      <div class="flex flex-col">
        <label for="role-admin" class="text-sm font-medium text-gray-700">
          Admin <i class="pi pi-shield text-green-600 text-xs"></i>
        </label>
        <span class="text-xs text-gray-500"> Can access the admin site </span>
      </div>
      <ToggleSwitch id="role-admin" v-model="isAdmin" :disabled="disabled" />
    </div>

    <!-- Network Admin Warning -->
    <Message v-if="showNetworkWarning" severity="warn" :closable="false">
      <div class="text-sm">
        <p class="font-medium">
          Since the organization you selected is a <strong>network</strong>,
          this user will automatically be an <strong>admin</strong>.
        </p>
        <p class="mt-1">
          They will be able to control all child clubs/network.
        </p>
      </div>
    </Message>
  </div>
</template>

<script setup lang="ts">
import ToggleSwitch from "primevue/toggleswitch";
import Message from "primevue/message";

interface Props {
  disabled?: boolean;
  showNetworkWarning?: boolean;
}

defineProps<Props>();

const isAdmin = defineModel<boolean>("isAdmin", { default: false });
</script>
